import React from 'react';
import { SupportedLanguage } from '../../../config/constants/supportedLanguage.enum';
import { ContactUsText, ContactUsLink } from '../sharedStyles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

export interface IContactLinkProps {
    locale: SupportedLanguage;
    supportLink: string;
}

export const getContactHref = (locale: SupportedLanguage, supportLink: string): string => {
    switch (locale) {
        case SupportedLanguage.EN_UK:
        case SupportedLanguage.ES_ES:
        case SupportedLanguage.DE_DE:
        case SupportedLanguage.UK_UA:
            return supportLink;
        default:
            return '';
    }
};

export const ContactLink = ({ locale, supportLink }: IContactLinkProps) => {
    if (
        locale !== SupportedLanguage.EN_UK &&
        locale !== SupportedLanguage.ES_ES &&
        locale !== SupportedLanguage.DE_DE &&
        locale !== SupportedLanguage.UK_UA
    ) {
        return <></>;
    }

    return (
        <>
            <ContactUsText>
                {TranslationHelpers.getFormattedMessage('ucrm.contact.us.text')}
            </ContactUsText>

            <ContactUsLink
                data-qa-id="contact-us-link"
                href={getContactHref(locale, supportLink)}
                target="_blank"
            >
                {TranslationHelpers.getFormattedMessage('notifications.redirect.here')}
            </ContactUsLink>
        </>
    );
};
